import { combineReducers } from 'redux';
import account, { CookieInformationAccountState } from './cookieInformationAccount';

export interface CookieInformationState {
  cookieInformation: {
    account: CookieInformationAccountState
  }
}

export default combineReducers({
  account,
});
